(window as any).__disable_follow_system_theme = true;
